import CaseStatusCard from './CaseStatusCard';

export const I18N_PREFIX = 'dashboard.cards.caseStatus';

export * from './CaseStatusCard';
export default CaseStatusCard;
